import React from "react";
import AdSense from 'react-adsense';
import "../App.css";

export default function AdsenseContent3() {
  return (
    <section className="atmequiz_main_page_text_ad_section">
      <div className="atmequiz_game_page_add_text_gridbox">
        <div className="atmequiz_game_page_container">
          <div className="atmequiz_game_page_text_ad_div">
            <span className="atmequiz_page_span_text">Block 3</span>
            <div className="atmequiz_game_page_ad_box">
              <a href="/">
                <img src="" alt="" />
                <AdSense.Google
                  client='ca-pub-7292810486004926'
                  slot='780'
                  style={{ display: 'block' }}
                  layout='in-article'
                  format='fluid'
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
